'use client';

import { motion } from 'framer-motion';

interface VideoControlsProps {
  isPlaying: boolean;
  progress: number;
  volume: number;
  showSubtitles: boolean;
  onTogglePlay: () => void;
  onToggleSubtitles: () => void;
  onVolumeChange: (volume: number) => void;
  onSeek: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function VideoControls({
                                        isPlaying,
                                        progress,
                                        showSubtitles,
                                        onTogglePlay,
                                        onToggleSubtitles,
                                        onSeek,
                                      }: VideoControlsProps) {
  const safeProgress = isNaN(progress) ? 0 : progress;

  return (
    <motion.div
      className="absolute top-full left-0 right-0 mt-2"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
    >
      {/* Minimalistische Controls mit Fortschrittsleiste und CC-Button */}
      <div className="flex items-center gap-3 bg-gray-900/90 backdrop-blur-sm p-2 rounded-lg shadow-lg">
        {/* Play/Pause */}
        <button
          onClick={onTogglePlay}
          className="text-white hover:text-[#62d6fc] transition-colors"
        >
          {isPlaying ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="6" y="4" width="4" height="16"></rect>
              <rect x="14" y="4" width="4" height="16"></rect>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
          )}
        </button>

        {/* Progress Bar */}
        <div className="flex-1">
          <input
            type="range"
            min="0"
            max="100"
            value={String(safeProgress)}
            onChange={onSeek}
            className="w-full h-1 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-[#ff88ff]"
          />
        </div>

        {/* CC Button - prominenter gestaltet */}
        <button
          onClick={onToggleSubtitles}
          className={`px-3 py-1 rounded-md font-bold text-sm transition-colors ${
            showSubtitles ? 'bg-[#ff88ff] text-white' : 'bg-gray-700 text-gray-300 hover:bg-[#ff88ff]/70'
          }`}
        >
          CC
        </button>
      </div>
    </motion.div>
  );
}